import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WaitlistActionsComponent } from './waitlist-actions.component';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2Module } from 'angulartics2';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendPaidFeatureModule } from '@tablesready/frontend-paid-feature-alert';

import { CloseDropdownOnScrollDirective } from '../../directives';

@NgModule({
  declarations: [WaitlistActionsComponent],
  imports: [
    CommonModule,
    NgbTooltipModule,
    FrontendIconsModule,
    Angulartics2Module,
    NgbDropdownModule,
    FrontendPaidFeatureModule,
    CloseDropdownOnScrollDirective,
  ],
  exports: [WaitlistActionsComponent],
})
export class WaitlistActionsModule {}
